import { render, staticRenderFns } from "./RegistrarMovimientoItemDialogComponent.vue?vue&type=template&id=c5f077a2"
import script from "./RegistrarMovimientoItemDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistrarMovimientoItemDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports